<template>
  <base-dialog
    :visible.sync="dialogVisible"
    class="verify-confirm-dialog"
    border-radius="none"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="510px"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">
          提示
        </div>
      </div>
    </template>
    <div style="min-height: 200px">
      <div
        class="fields"
        :class="commentSetting.show ? 'border' : ''"
        v-if="!structLoading && fillControlCids.length"
        v-loading="loading"
      >
        <form-group
          ref="formGroup"
          class="form-wrap"
          hide-title
          :groups="[{ controls: fillControls }]"
          :sheetDataServer="sheetDataServer"
          :form-util="formUtil"
          @update="handleFieldUpdate"
          @refDataCreated="handleRefDataCreated"
        ></form-group>
        <sub-table
          v-for="control in fillRelatedControls"
          ref="relatedControl"
          :key="control._cid"
          :parent-data="{ id: dataId, data: form }"
          :only-required="onlyRequired"
          :control="control"
          :available-sheets="availableSheets"
          :fill-setting="getRefTableFillCid(control)"
          :from="from"
          @change="handleRelatedControlChange(control, $event)"
          class="related-control"
        ></sub-table>
        <ref-control
          ref="refControl"
          v-if="fillRefControls.length > 0"
          :only-required="onlyRequired"
          :controls="fillRefControls"
          :availableSheets="availableSheets"
          :form="form"
          :sheetId="sheetId"
          :sheetData="sheetData"
          class="ref-control"
          @full-screen="fullScreen = $event"
          @update="handleRefControlChange"
        ></ref-control>
      </div>
      <div class="system">
        <div class="item" v-if="commentSetting.show">
          <div class="label">
            {{ promptTitle }}
            <span v-if="commentSetting.required" style="color: red">*</span>
          </div>
          <rich-input ref="rich" v-model="val"></rich-input>
        </div>
        <div class="item signature" v-if="signSetting.show">
          <div class="label">
            签名
            <span v-if="signSetting.required" style="color: red">*</span>
          </div>
          <signature
            ref="signature"
            placeholder="请添加签名"
            :value="sign"
            @output="setSign"
          ></signature>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <template v-if="submitDirectly">
        <base-button type="primary" @click="submit">保存</base-button>
        <base-button @click="close">取消</base-button>
      </template>
      <template v-else>
        <base-button type="primary" @click="submit(true)">仅保存</base-button>
        <base-button type="primary" @click="submit(false)">保存并完成</base-button>
        <base-button @click="close">取消</base-button>
      </template>
    </template>
  </base-dialog>
</template>

<script>
import EditDialog from "@/components/Sheet/EditDialog"
import RefControl from "@/components/Sheet/EditDialog/RefControl"
import { beforeSubmit, transFieldControl } from "@/utils/sheet"
import RichInput from "@/components/FormControl/RichInput"
import Signature from "@/components/BaseComponents/Signatue"
import { loadingService } from "@/utils/ui"
import { getAvailableSheets, getSheetDefForEdit } from "@/api/sheet/sheet"
import { initUserData } from "@/utils/user"
import { initLocation } from "@/utils/location"
import FormUtil from "@/components/Sheet/EditDialog/FormUtil"

export default {
  name: "VerifyConfirmDialog",
  extends: EditDialog,
  components: {
    Signature,
    RichInput,
    RefControl
  },
  props: {
    verify: Object,
    pass: Boolean,
    sheetId: String,
    dataId: String
  },
  data() {
    return {
      submitDirectly: true,
      val: null,
      sign: null,
      visible: false,
      form: {}
    }
  },
  computed: {
    promptTitle() {
      return `确认${this.pass ? this.verify.acceptButtonName : this.verify.rejectButtonName}${
        this.verify.name
      }么?`
    },
    fillCids() {
      return this.pass ? this.verify.acceptFillCids : this.verify.rejectFillCids
    },
    fillControlCids() {
      return this.fillCids.filter(item => !["verifyComments", "verifySign"].includes(item.cid))
    },
    commentSetting() {
      let comment = this.fillCids.find(item => item.cid === "verifyComments")
      return { show: comment.type !== "R", required: comment.type === "H" }
    },
    signSetting() {
      let sign = this.fillCids.find(item => item.cid === "verifySign")
      return { show: sign.type !== "R", required: sign.type === "H" }
    },
    fillCidMap() {
      return this._.chain(this.fillCids || [])
        .keyBy("cid")
        .mapValues("type")
        .value()
    },
    controls() {
      let cids = (this.fillCids || []).map(t => t.cid)
      return (this._.cloneDeep(this.sheetInfo.controls) || [])
        .filter(control => cids.includes(control._cid))
        .map(control => {
          control = transFieldControl(control)
          if (this.fillCidMap[control._cid] === "R") {
            control.disabled = true
          } else if (this.fillCidMap[control._cid] === "H") {
            control.required = true
          }
          return control
        })
        .sort((a, b) => {
          // 按照按钮设置的顺序填写
          return cids.findIndex(cid => cid === a._cid) - cids.findIndex(cid => cid === b._cid)
        })
    },
    fillControls() {
      return this.controls.filter(c => c._type !== "ref" || c.oneFlag)
    },
    fillRelatedControls() {
      let cids = this.relatedControls.map(c => c._cid)
      return this.controls.filter(c => cids.includes(c._cid))
    },
    fillRefControls() {
      let cids = this.refControls.map(c => c._cid)
      return this.controls.filter(c => cids.includes(c._cid))
    }
  },
  methods: {
    async open(sign) {
      await this.$nextTick() // 等待props传入
      if (this.fillControlCids.length) {
        this.onlyRequired = false
        this.status.initial = true
        this.loading = true
        this.structLoading = true
        // initUserData 是为了编辑修改用户字段的时候,能直接根据用户,获取到用户所在部门,然后填充给部门的默认值
        const sheetInfo = await getSheetDefForEdit(this.sheetId, this.dataId)
        this.sheetInfo = this._.cloneDeep(sheetInfo)
        this.dialogVisible = true // 尽快弹出窗口,避免打开延迟过高
        this.val = null
        this.sign = this.signSetting.show ? sign : null
        const [availableSheets] = await Promise.all([
          getAvailableSheets({ appId: this.appId }),
          initUserData(this.appId),
          initLocation(),
          this.getFrontSetting()
        ])
        this.formUtil = new FormUtil({
          dataId: this.dataId,
          sheetInfo: sheetInfo,
          availableSheets: availableSheets,
          fillFields: this.fillControls, // 当fillDialog执行时，有这个参数
          formGetterFunc: () => this.form,
          updateFormFunc: ({ updateObj, initFromGroup = false, isFromSubTable = false }) => {
            this.form = Object.assign({}, this.form, updateObj)
            this.calcSheetDataServerDebounced()
            initFromGroup && this.$refs.formGroup?.init(this.form, Object.keys(updateObj))
            !isFromSubTable &&
              this.$refs.relatedControl?.forEach(component => component.onParentUpdateDebounced())
          }
        })
        this.availableSheets = Object.freeze(availableSheets)
        this.structLoading = false
        // 初始化表单
        this.divideIntoGroups(sheetInfo)
        this.formUtil.sheetDefUpdateCbk = sheetInfo => {
          // 用于字段规则改变时,重新初始化表单
          this.sheetInfo = sheetInfo
          this.divideIntoGroups(sheetInfo)
          this.$nextTick(() => this.commonInit())
        }
        await this.$nextTick()
        switch (this.from) {
          case "verify": // 审批同意填写
            await this.getSheetData().then(() => this.commonInit())
            break
        }
        this.loading = false
        setTimeout(() => this.broadcast("rich", "force-update"))
      } else {
        this.dialogVisible = true
        this.val = null
        this.sign = this.signSetting.show ? sign : null
        this.$nextTick(() => this.$refs.rich.forceUpdate())
      }
    },
    getRefTableFillCid(control) {
      return (this.fillControlCids || []).find(t => t.cid === control._cid)?.subList || []
    },
    async submit() {
      if (this.fillControlCids.length) {
        if (this.loading) {
          this.$message.warning("请等待加载完成后操作")
          return
        }
        if (!(await this.validate())) {
          this.scrollToFormValidateErr()
          return
        }
      }
      if (this.commentSetting.required && !this.val) {
        this.$message.error("请填写审批意见后重新提交")
        return
      }
      if (this.signSetting.required && this._.isEmpty(this.sign)) {
        this.$message.error("请填写签名后重新提交")
        return
      }
      const loading = loadingService({ text: "请求中" })
      try {
        let submitData = {}
        if (this.fillControlCids.length) {
          submitData = beforeSubmit({ form: this.form, fieldsMap: this.formUtil.controlMap })
        }
        this.$emit("submit", this.val, this.sign, submitData)
        this.dialogVisible = false
      } finally {
        loading.close()
      }
    },
    setSign(sign) {
      this.sign = sign
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-confirm-dialog {
  .fields {
    margin-bottom: 15px;
  }
  .border {
    border-bottom: 1px solid #e4e4e4;
  }
  .system {
    .item {
      margin-top: 10px;
      .label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
      }
    }
    .signature {
      width: 240px;
    }
  }
  ::v-deep {
    .el-dialog {
      max-height: 520px;
    }
    .el-dialog__body {
      position: relative;
      padding: 0 22px 18px 22px;
    }
    .form-group-items {
      flex-flow: column;
      margin-bottom: 15px;
    }
    .sub-data .title-container::before {
      left: -10px;
    }
  }
  .ref-control {
    padding-top: 64px;
    padding-right: 4px;
    box-sizing: border-box;
    ::v-deep .sheet-table {
      margin-left: -22px;
    }
  }
  .related-control {
    padding-top: 16px;
    padding-right: 4px;
    box-sizing: border-box;
    ::v-deep .el-table--border {
      min-width: 450px;
    }
  }
}
</style>
